import request from '@/utils/request'

/*
 * 首页
 */
export const getRecentCalls = (params) => {
  return request('meeting/recent/calls', params, 'get')
}
export const getRecentMissed = (params) => {
  return request('meeting/recent/missed', params, 'get')
}
export const getRoomId = (params) => {
  return request('meeting/queue/roomid', params, 'get')
}
export const getQueue = (params) => {
  return request('meeting/queue', params, 'get')
}
export const join = (params) => {
  return request('meeting/meeting/join', params, 'post')
}
export const requestCall = (params) => {
  return request('meeting/requestCall', params, 'post')
}
export const leave = (params) => {
  return request('meeting/meeting/leave', params, 'post')
}
export const customerCancel = (params) => {
  return request('meeting/customerCancel', params, 'post')
}
export const staffCancel = (params) => {
  return request('meeting/staffCancel', params, 'post')
}
export const heartJump = (params) => {
  return request('meeting/recent/calls', params, 'get')
}
export const alive = (params) => {
  return request('meeting/meeting/alive', params, 'post')
}